import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import {environment} from '../../../environments/environment';
import {Authorizations, CartItem, CustomerOP} from '../interfaces';
import {Address} from '../models';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  constructor() {
  }

  getCart(): Observable<string[]> {
    return of(JSON.parse(sessionStorage.getItem(environment.sessionData)));
  }

  setCartByUser(user: string, newCart: CartItem[]): void {
    let session = {carts: {}};
    if (sessionStorage.getItem(environment.sessionData)) {
      session = JSON.parse(sessionStorage.getItem(environment.sessionData));
      if (!session.carts) {
        session.carts = {};
      }
    }
    session.carts[user] = newCart;
    sessionStorage.setItem(environment.sessionData, JSON.stringify(session));
  }

  getCartByUser(user: string): CartItem[] {
    if (sessionStorage.getItem(environment.sessionData)) {
      const session = JSON.parse(sessionStorage.getItem(environment.sessionData));
      if (!session.carts) {
        session.carts = {};
      }
      return session.carts[user] ? session.carts[user] : [];
    } else {
      return [];
    }
  }

  setAutorizathion(user: string, auth): void {
    let permiss = {};
    if (sessionStorage.getItem('authorization')) {
      permiss = JSON.parse(sessionStorage.getItem('authorization'));
      if (!permiss[user]) {
        permiss[user] = [];
      }
    }
    permiss[user] = auth;
    sessionStorage.setItem('authorization', JSON.stringify(permiss));
  }

  getAutorizathion(user: string): Authorizations[] {
    if (sessionStorage.getItem('authorization')) {
      const auth = JSON.parse(sessionStorage.getItem('authorization'));
      if (!auth[user]) {
        auth[user] = [];
      }
      return auth[user] ? auth[user] : [];
    } else {
      return [];
    }
  }

  updateCustomer(addressCustomer: CustomerOP, address: Address[]): 'N' | 'Y' {
    const info: CustomerOP = JSON.parse(JSON.stringify(addressCustomer));
    const addressCart: Address[] = JSON.parse(JSON.stringify(address));
    if (addressCustomer.id) {
      const dataCurrent = info.information.dataCurrent;
      const dataCustomer = dataCurrent
        && dataCurrent.name.toUpperCase() === info.information.name.toUpperCase()
        && dataCurrent.lastName.toUpperCase() === info.information.lastName.toUpperCase();

      const customerContact = dataCurrent.contactInfo.filter(contact => {
        return contact.contact === info.information.email
          || contact.contact === info.information.phone;
      });
      const validAddress = addressCart.filter(i => {
        const exis = dataCurrent.addresses.find(add => {
          return add.address.toUpperCase() === i.address.toUpperCase()
            && add.number === i.number
            && add.latitude === i.latitude
            && add.longitude === i.longitude;
        });
        return !exis ? true : false;
      });
      return validAddress.length || !dataCustomer || customerContact.length <= 1 ? 'Y' : 'N';
    } else {
      return 'Y';
    }
  }

}
